/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import './ng_dev_mode';
import { assertNotNull } from './assert';
/**
 * @param {?} nodeClassAttrVal
 * @param {?} cssClassToMatch
 * @return {?}
 */
function isCssClassMatching(nodeClassAttrVal, cssClassToMatch) {
    var /** @type {?} */ nodeClassesLen = nodeClassAttrVal.length;
    var /** @type {?} */ matchIndex = /** @type {?} */ ((nodeClassAttrVal)).indexOf(cssClassToMatch);
    var /** @type {?} */ matchEndIdx = matchIndex + cssClassToMatch.length;
    if (matchIndex === -1 // no match
        || (matchIndex > 0 && /** @type {?} */ ((nodeClassAttrVal))[matchIndex - 1] !== ' ') // no space before
        ||
            (matchEndIdx < nodeClassesLen && /** @type {?} */ ((nodeClassAttrVal))[matchEndIdx] !== ' ')) {
        return false;
    }
    return true;
}
/**
 * A utility function to match an Ivy node static data against a simple CSS selector
 *
 * @param {?} lNodeStaticData
 * @param {?} selector
 * @return {?} true if node matches the selector.
 */
export function isNodeMatchingSimpleSelector(lNodeStaticData, selector) {
    var /** @type {?} */ noOfSelectorParts = selector.length;
    ngDevMode && assertNotNull(selector[0], 'selector[0]');
    var /** @type {?} */ tagNameInSelector = selector[0];
    // check tag tame
    if (tagNameInSelector !== '' && tagNameInSelector !== lNodeStaticData.tagName) {
        return false;
    }
    // short-circuit case where we are only matching on element's tag name
    if (noOfSelectorParts === 1) {
        return true;
    }
    // short-circuit case where an element has no attrs but a selector tries to match some
    if (noOfSelectorParts > 1 && !lNodeStaticData.attrs) {
        return false;
    }
    var /** @type {?} */ attrsInNode = /** @type {?} */ ((lNodeStaticData.attrs));
    for (var /** @type {?} */ i = 1; i < noOfSelectorParts; i += 2) {
        var /** @type {?} */ attrNameInSelector = selector[i];
        var /** @type {?} */ attrIdxInNode = attrsInNode.indexOf(attrNameInSelector);
        if (attrIdxInNode % 2 !== 0) {
            // attribute names are stored at even indexes
            return false;
        }
        else {
            var /** @type {?} */ attrValInSelector = selector[i + 1];
            if (attrValInSelector !== '') {
                // selector should also match on an attribute value
                var /** @type {?} */ attrValInNode = attrsInNode[attrIdxInNode + 1];
                if (attrNameInSelector === 'class') {
                    // iterate over all the remaining items in the selector selector array = class names
                    for (i++; i < noOfSelectorParts; i++) {
                        if (!isCssClassMatching(attrValInNode, selector[i])) {
                            return false;
                        }
                    }
                }
                else if (attrValInSelector !== attrValInNode) {
                    return false;
                }
            }
        }
    }
    return true;
}
/**
 * @param {?} lNodeStaticData
 * @param {?} selector
 * @return {?}
 */
export function isNodeMatchingSelectorWithNegations(lNodeStaticData, selector) {
    var /** @type {?} */ positiveSelector = selector[0];
    if (positiveSelector != null &&
        !isNodeMatchingSimpleSelector(lNodeStaticData, positiveSelector)) {
        return false;
    }
    // do we have any negation parts in this selector?
    var /** @type {?} */ negativeSelectors = selector[1];
    if (negativeSelectors) {
        for (var /** @type {?} */ i = 0; i < negativeSelectors.length; i++) {
            // if one of negative selectors matched than the whole selector doesn't match
            if (isNodeMatchingSimpleSelector(lNodeStaticData, negativeSelectors[i])) {
                return false;
            }
        }
    }
    return true;
}
/**
 * @param {?} lNodeStaticData
 * @param {?} selector
 * @return {?}
 */
export function isNodeMatchingSelector(lNodeStaticData, selector) {
    for (var /** @type {?} */ i = 0; i < selector.length; i++) {
        if (isNodeMatchingSelectorWithNegations(lNodeStaticData, selector[i])) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=node_selector_matcher.js.map